import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { cartDispatcher, identityState, apttusDispatcher, combineDispatchers, cartState, combineStates } from '../../store';
import { IconButton } from '..';
import { translate } from '../../services';

const StatusMessage = ( { status } ) => {
  return <li>
    { status }
  </li>;
};

export class SaveToApttusComponent extends Component {
  onGo = returnUrl => {
    const { apttusUrl, cart } = this.props;
    this.props.deleteFromCart();
    window.close();
    window.location.href = returnUrl? returnUrl: apttusUrl;
  }

  deleteFromCart = items => {
    for(const item of items ){
      this.props.deleteFromCart( item );
    }
  }

  renderChangeLog(statusLog) {
    return statusLog.map( ( status ) => <StatusMessage status={ status } /> );
  }

  hidePopup = () => this.props.hidePopup();
  render() {
    const {response, user, apttusUrl} = this.props
    let unsavedData;
    let savedData;
    let statusLog=[];
    let message = user.properties.CallingApp === "Apttus" ||  user.properties.CallingApp === "ELAPTTUS" ? 'Continue To Apttus' : 'Continue To BOL';
    let failMessage = user.properties.CallingApp === "Apttus" ||  user.properties.CallingApp === "ELAPTTUS" ? 'Save to Apttus failed -' : 'Save to BOL failed -';
    let returnUrl = '';
    let isSaveFailed = false;
    let isSaveSucceded = false;

    if(response){
    for ( let configResponse of response ) {
      if ( configResponse.paramApptusSaveError.toLowerCase().indexOf('success') > -1 ) {
        isSaveSucceded = true;
        returnUrl = configResponse.paramApttusUrl;
        savedData = ( !savedData ? configResponse.paramConfigurationId : savedData + "," + configResponse.paramConfigurationId );
        statusLog.push(configResponse.paramConfigurationId+" : " + translate('saved'));
      }
      else {
        isSaveFailed = true;
        unsavedData = ( !unsavedData ? configResponse.paramConfigurationId : unsavedData + "," + configResponse.paramConfigurationId );
        statusLog.push(configResponse.paramConfigurationId+" : " + translate(failMessage) + configResponse.paramApptusSaveError);
        returnUrl = configResponse.paramApttusUrl;
      }
    }

    if(!isSaveFailed && isSaveSucceded){
      window.close();
      this.onGo(returnUrl);
      return null;
    }
  }
  else{
    statusLog.push("Save action failed");
  }
    return <div className="apttus-status-window" >
      <div className="success-status-message-window" >
        <h4>{ translate( 'Status' ) }</h4>
        <ul>{ this.renderChangeLog(statusLog) }</ul>
      </div>
      <div className="apttus-actions" >
        {(!isSaveSucceded && isSaveFailed) && <IconButton text={ translate( 'Cancel_Apttus' ) } onClick={ this.hidePopup } fromApttus = {true} />}
        {(apttusUrl || returnUrl) && <IconButton className="blue-button" text={ message } onClick={ this.onGo.bind(this, returnUrl) } fromApttus = {true} />}
      </div>
    </div>;
  }
}

SaveToApttusComponent.propTypes = {
  cartItems: PropTypes.arrayOf( PropTypes.shape( {} ) ),

};

export const SaveToApttus = connect(combineStates(identityState, cartState), combineDispatchers( cartDispatcher, apttusDispatcher ) )( SaveToApttusComponent );